<template>
  <div class="detail-page-metrics-step">
    <div class="intro-text">
      <Typography variant="h-5">Program Detail Page</Typography>
      <Typography variant="body-1">
        Configure the "Your Progress" section participants see on the program detail page. Add rows,
        drop in metrics, and click any metric to configure it. Your summary card metrics are
        pre-loaded as a starting point — keep, edit, or add more. At least one row and one metric is
        required.
      </Typography>
    </div>

    <div class="metrics-list-header">
      <Typography variant="subtitle-1">Progress Metrics List</Typography>
      <Button text iconLeft="mdi-plus" data-testid="add-row-btn" @click="$refs.rowsEditor.addRow()">
        Add Row
      </Button>
    </div>

    <MetricRowsEditor
      ref="rowsEditor"
      :rows="rows"
      :metric-options="metricOptions"
      :inform-program-id="informProgramId"
      :metric-options-error="metricOptionsError"
      :metric-options-loaded="metricOptionsLoaded"
      :metric-options-reason="metricOptionsReason"
      require-configured-metric
      @update:rows="$emit('update:rows', $event)"
    />
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import MetricRowsEditor from "./MetricRowsEditor.vue";

export default {
  name: "DetailPageMetricsStep",
  components: { Typography, Button, MetricRowsEditor },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    metricOptions: { type: Array, default: () => [] },
    informProgramId: { type: String, default: null },
    metricOptionsError: { type: Boolean, default: false },
    metricOptionsLoaded: { type: Boolean, default: false },
    metricOptionsReason: { type: String, default: null },
  },
  emits: ["update:rows"],
  methods: {
    validate() {
      return this.$refs.rowsEditor.validate();
    },
  },
};
</script>

<style scoped>
.detail-page-metrics-step {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.intro-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.metrics-list-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
</style>
